export default "__VITE_ASSET__6eb2cb71__"